import moment from "moment";

const formatNumber = (value, decimals) => Number(value).toFixed(decimals);

export const getMetricDifferenceClass = (difference, increaseIsGood) => {
  const isGood = difference === 0 || (increaseIsGood ? difference > 0 : difference < 0);
  return isGood ? "metric-history-table__difference--good" : "metric-history-table__difference--bad";
};

export const buildMetricHistoryRows = (entries, decimals = 0, toDate = moment()) => {
  const valuesByDate = (entries || []).reduce((result, entry) => {
    if (!entry || !entry.date) {
      return result;
    }

    const value = Number(entry.value);
    const date = moment(entry.date);

    if (date.isValid() && Number.isFinite(value)) {
      result.set(date.format("YYYY-MM-DD"), value);
    }

    return result;
  }, new Map());

  if (!valuesByDate.size) {
    return [];
  }

  const sortedDates = Array.from(valuesByDate.keys()).sort();
  const firstDate = moment(sortedDates[0]).startOf("day");
  const lastDate = moment.max(firstDate.clone(), moment(toDate).startOf("day"));
  const groups = [];
  let groupItems = [];
  let groupValues = [];

  for (let date = firstDate.clone(); date.isSameOrBefore(lastDate); date.add(1, "day")) {
    const dateKey = date.format("YYYY-MM-DD");
    const hasValue = valuesByDate.has(dateKey);
    const value = valuesByDate.get(dateKey);

    groupItems.push({
      date: dateKey,
      value: hasValue ? formatNumber(value, decimals) : null,
    });

    if (hasValue) {
      groupValues.push(value);
    }

    if (date.locale("en").weekday() === 0 || date.isSame(lastDate, "day")) {
      const average = groupValues.length
        ? Number(formatNumber(groupValues.reduce((sum, current) => sum + current, 0) / groupValues.length, decimals))
        : null;
      const previousGroup = [...groups].reverse().find((group) => group.numericValue !== null);
      const difference = average !== null && previousGroup ? average - previousGroup.numericValue : null;
      const startDate = groupItems[0].date;
      const endDate = groupItems[groupItems.length - 1].date;

      groups.push({
        key: `${startDate}_${endDate}`,
        title: `tjedan ${moment(endDate).format("YYYY-MM")}`,
        value: average === null ? null : formatNumber(average, decimals),
        numericValue: average,
        difference,
        formattedDifference:
          difference === null ? null : `${difference > 0 ? "+" : ""}${formatNumber(difference, decimals)}`,
        isExpanded: false,
        items: groupItems.reverse(),
      });

      groupItems = [];
      groupValues = [];
    }
  }

  return groups.reverse();
};
